import React, {useState} from 'react'
import {connect} from "react-redux"
import { makeStyles } from '@material-ui/core/styles'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import { userActions } from "../../../actions/userActions"

import { projectPricesServices } from '../../../services/projectPricesServices'
import { userService } from '../../../services/userService'
import {userConstants} from "../../../constants/userConstants";

const useStyles = makeStyles({
    list: {
        listStyle: 'auto',
        margin: '5px 0'
    },
});


const TermsOfUse = function (props) {
    const [open, setOpen] = useState(true);
    const classes = useStyles();
    let termsOfUseSetting = false;

    if (props.hasOwnProperty('settings')) {
         termsOfUseSetting =  props.settings.project_prices.terms_of_use;
    }

    const handleClose = () => {
        props.logout()
    };

    const onAcceptTermsOfUse = () => {
        function success(user) { return { type: userConstants.USER_INFO_SUCCESS, user } }

        projectPricesServices.acceptTermsOfUse()
        let userData = userService.getInfo();
        userData.settings.project_prices.terms_of_use = true
        // props.dispatch(success({user: userData}))
        props.update({user: userData})
        setOpen(false)
    }

    return <>
        {!termsOfUseSetting && (
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth={'lg'}
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
                scroll={'paper'}
            >
                <DialogTitle>{"REGULAMIN STREFY CEN PROJEKTOWYCH W AB ONLINE"}</DialogTitle>
                <DialogContent>
                    <ol>
                        <li className={classes.list}>
                            Niniejszy Regulamin określa zasady korzystania przez Dealera ze Strefy Cen Projektowych w Systemie AB Online.
                        </li>
                        <li className={classes.list}>
                            W zakresie nieuregulowanym w niniejszym Regulaminie mają zastosowanie postanowienia Regulaminu AB Online.
                        </li>
                        <li className={classes.list}>
                            W Strefie Cen Projektowych Dystrybutor udostępnia Dealerowi informacje na temat cen specjalnych przyznanych Dealerowi przez Dystrybutora lub producenta w związku z realizacją przez Dealera sprzedaży projektowych..
                        </li>
                        <li className={classes.list}>
                            Przez sprzedaż projektową rozumie się sprzedaż przez Dealera produktów do klienta końcowego zgodnie ze zgłoszonym przez Dealera zapotrzebowaniem i ofertą złożoną przez Dystrybutora lub producenta, określającą w szczególności: produkt, cenę zakupu Dealera od Dystrybutora lub wysokość rabatu przysługującego Dealerowi, maksymalną ilość produktów oferowanych w tej cenie, dane klienta końcowego, termin obowiązywania oferty.
                        </li>
                        <li className={classes.list}>
                            W przypadku złożenia Dealerowi oferty przez producenta, jej realizacja przez Dystrybutora wymaga uprzedniego potwierdzenia tej oferty przez Dystrybutora.
                        </li>
                        <li className={classes.list}>
                            Dystrybutor udostępnia Dealerowi w Strefie Cen Projektowych aktualne informacje na temat przysługujących mu cen specjalnych na produkty (ceny netto), ilości produktów możliwych do zakupu przez Dealera w cenie specjalnej, terminu obowiązywania cen specjalnych, numer projektu oraz dane klienta końcowego, dla którego obowiązuje projekt.
                        </li>
                        <li className={classes.list}>
                            Aby zakupić towar w cenie specjalnej Dealer powinien wybrać produkt w Strefie Cen Projektowych, wskazać jego ilość oraz dodać go do Koszyka.
                        </li>
                        <li className={classes.list}>
                            Każdy zakup produktu w cenie specjalnej pomniejsza dostępną dla Dealera ilość produktów w cenie specjalnej.
                        </li>
                        <li className={classes.list}>
                            Dane w Strefie Cen Projektowych mają wyłącznie charakter informacyjny i nie stanowią oferty w rozumieniu kodeksu cywilnego. Realizacja zamówień złożonych w oparciu o informacje zawarte w Strefie Cen Projektowych następuje na zasadach określonych w Regulaminie AB Online, z uwzględnieniem Warunków Współpracy Dealera i Dystrybutora, oferty producenta lub Dystrybutora dotyczącej przyznanych cen specjalnych, a także wszelkich dodatkowych umów lub regulaminów przyznawania cen specjalnych określonych przez producenta lub Dystrybutora.
                        </li>
                        <li className={classes.list}>
                            Dealer zobowiązany jest do weryfikacji przysługującego mu limitu produktów oferowanych w cenie specjalnej wskazanego w Strefie Cen Projektowych przed złożeniem zamówienia i w razie stwierdzenia błędu w informacjach tam zawartych, zobowiązany jest niezwłocznie poinformować o tym Dystrybutora.
                        </li>
                        <li className={classes.list}>
                            Jeżeli Dealer zamówi produkty w ilości powodującej przekroczenie maksymalnego limitu produktów oferowanych w cenie specjalnej w ofercie Dystrybutora lub producenta, Dystrybutor ma prawo odstąpić od zamówienia, a w razie gdyby towar został już Dealerowi wydany, Dealer zobowiązany będzie zwrócić Dystrybutorowi różnicę między ceną specjalną a ceną wskazaną w Systemie aktualną w dniu wystawienia faktury przez Dystrybutora. W takim wypadku Dystrybutor wystawi Dealerowi stosowną korektę zwiększającą do faktury VAT.
                        </li>
                    </ol>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Odrzuć
                    </Button>
                    <Button onClick={onAcceptTermsOfUse} color="primary">
                        Akceptuję
                    </Button>
                </DialogActions>
            </Dialog>
        )}
        </>
}

const mapStateToProps = (state) => {
    return {
        settings: state.user?.settings,
    };
};

const actionCreators = {
    logout: userActions.logout,
    update: userActions.update
};

export default connect(mapStateToProps, actionCreators)(TermsOfUse);
